<!-- Banner "¡Conoce al ganador del 1er sorteo!".
     El arte de referencia (assets/images/sorteo2026/sorteo-prepa/1.png) es
     banner-prepa.jpg de fondo con el logo y el titulo encimados sobre la
     mitad derecha, donde la foto es solo estacionamiento y cielo.
     Aqui no se usa el PNG con el texto quemado: el fondo va como imagen y
     el texto se arma con tipografia del sitio, para que escale sin
     pixelearse y se pueda reacomodar en celular. -->
<section class="hero-prepa-ganador">

    <!-- El <img> (y no un background-image) es el fondo, para que cuente
         como imagen de contenido y lleve alt. En desktop se le fija un alto
         menor al de su proporcion 16:9 y se recorta con object-fit: cover,
         porque a pantalla completa el banner se comia toda la ventana. -->
    <img src="/assets/images/sorteo2026/sorteo-prepa/banner-prepa.jpg" class="hpg-fondo"
        alt="Sorteo Especial Rumbo a tu Primer Auto: Kia K3 en el estacionamiento del campus">

    <!-- Velo oscuro sobre la mitad derecha. La foto ahi es cielo y asfalto
         claros, y el titulo blanco se perdia contra ellos; el degradado
         arranca transparente para no ensuciar el blister de la izquierda. -->
    <span class="hpg-overlay" aria-hidden="true"></span>

    <!-- En desktop este bloque va encimado sobre la mitad derecha de la
         foto; en celular (ver el scss) baja debajo de la imagen, sobre
         fondo solido, porque a ese ancho el texto encimado se montaba
         sobre el blister naranja y no se leia. -->
    <div class="hpg-texto">
        <div class="hpg-texto-wrap">
            <img src="/assets/images/sorteo2026/sorteo-prepa/logo.png" class="hpg-logo" alt="Sorteos Anáhuac">

            <h1 class="hpg-titulo">
                <span class="hpg-linea1">¡CONOCE</span>
                <span class="hpg-linea2"><span class="hpg-linea2-txt">AL GANADOR</span></span>
                <span class="hpg-linea3">DEL 1° SORTEO!</span>
            </h1>
        </div>
    </div>
</section>

<br><br>
<section class="stc-winners-opt so2">
    <div class="container">
        <div class="row">
            <div class="col-md-12 text-center">
                <h2 class="titulo-oficial">
                    GANADOR SORTEO ESPECIAL
                    <span class="d-block">
                        RUMBO A TU PRIMER AUTO 2026
                    </span>
                </h2>
            </div>

            <!-- Misma tabla que la lista de participantes (mismos colores y
                 encabezados .cols del sass global), pero sin buscador,
                 sin paginador y sin Excel: es un solo renglon fijo. -->
            <div class="col-md-12">
                <div class="text-center" style="overflow-x: auto;">
                    <table class="table table-striped table-hover mt-5">
                        <thead>
                            <tr class="cols">
                                <th scope="col" style="width: 30%;"><span>FOLIO</span></th>
                                <th scope="col" style="width: 70%;"><span>NOMBRE</span></th>
                            </tr>
                        </thead>
                        <tbody class="text-center">
                            <tr>
                                <td class="text-center align-middle" style="width: 30%;">
                                    <strong>{{ ganador.folio }}</strong>
                                </td>

                                <!-- Sin text-uppercase a proposito: el permiso pide el
                                     nombre propio y solo las iniciales de los apellidos
                                     ("Mariana T. G."), asi que las minusculas importan. -->
                                <td class="text-center align-middle" style="width: 70%;">
                                    {{ ganador.nombre }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>


            <!-- Legales del sorteo especial ya celebrado. Son los del acto
                 del sorteo (los dio el area, tal cual), no los de la lista de
                 participantes: aqui se da fe del evento y se explica como se
                 publica al ganador. -->
            <div class="col-12 mt-5 pt-0 footer-egr">
                <p class="font-bold">
                    SORTEO ESPECIAL RUMBO A TU PRIMER AUTO
                </p>

                <p>El Sorteo Anáhuac celebró el viernes 11 de septiembre de 2026, a las 10:15 horas, el Sorteo Especial Rumbo a tu primer auto en la Universidad Anáhuac México Campus Norte con domicilio en la Avenida Universidad Anáhuac no. 46 Col. Lomas Anáhuac. C.P. 52786 Huixquilucan, Estado de México con la presencia del C. <strong>Edgar Cortés Rodríguez</strong>, Inspector de la Secretaría de Gobernación, para dar fe de la legalidad del evento.</p>

                <p>De acuerdo con lo establecido en el Permiso No. <strong>20260230PS07</strong> otorgado por la Secretaría de Gobernación a Sorteo Anáhuac, A.C., el resultado del ganador, será publicado de forma posterior al evento del sorteo en la página de internet https://www.sorteoanahuac.mx/ y nuestras redes sociales a partir del día 12 de septiembre de 2026 y de acuerdo a lo registrado ante SEGOB, solo aparecerá el folio ganador, el nombre propio del ganador, completándose con las iniciales de cada uno de los apellidos, adicionalmente, se publicará la lista con el nombre completo del ganador en las Instalaciones de la Universidad Anáhuac México Campus Norte, ubicada en la Av. Universidad no. 46 Colonia Lomas de Anáhuac, CP. 52786, Huixquilucan Estado de México.</p>

                <p>Los premios mayores a 1,500 (UMA) $175,965.00 (Ciento setenta y cinco mil novecientos sesenta y cinco pesos 00/100 m.n.) se solicitará la presencia de un inspector de la DGJS para la entrega de estos, conforme al siguiente calendario de fechas: 25 de septiembre de 2026 a las 11:00 horas Entrega del Premio 1 del Sorteo Especial Rumbo a tu primer auto. En las instalaciones de la Universidad Anáhuac México Campus Norte con domicilio en Av. Universidad Anáhuac no. 46 Huixquilucan, Estado de México. C.P. 52786.</p>

                <p>Los premios serán pagados y entregados de conformidad con lo establecido en las bases de Sorteo. Para más información sobre dónde reclamar la entrega del premio, documentos necesarios para recibirlo diríjase a: www.sorteoanahuac.mx, o a la oficina del Sorteo Anáhuac, A.C. ubicada en la calle “Av. Universidad Anáhuac no. 46, Col. Lomas Anáhuac, C.P. 52786, Huixquilucan, Estado de México o al teléfono: 01(55) 5328-8096 ext 2137.</p>

                <p>La persona que resulte ganadora deberá presentar una identificación oficial vigente con fotografía (credencial INE, pasaporte), comprobante de domicilio (no mayor a tres meses) y CURP; el correo electrónico que le fue enviado con su folio correspondiente y su identificación oficial.</p>

                <p>En caso de queja derivada de este sorteo, la autoridad competente es la Dirección General de Juegos y Sorteos de la Secretaría de Gobernación ubicada en la calle de Versalles 49, piso 2, Col. Juárez, Del. Cuauhtémoc, C.P. 06600, Ciudad de México o bien comunicarse al teléfono: 01(55) 5209 8800.</p>
            </div>

        </div>
    </div>
</section>
